class VariantMetafield extends HTMLElement {
	constructor() {
		super();
		this.descriptions = window.variantMetafields || {}; 
		this.productImage = window.productSizeChartImage || null;
	}

	connectedCallback() {
		this.descriptionBox = this.querySelector(".fabric_information");
		document.addEventListener('click', (e) => {
		const btn = e.target.closest('.size-chart-link');
		if (btn) {
			const currentId = this.getCurrentVariantId();
			this.waitForSizeChartImgAndUpdate(currentId);
		}
    });

		this.variantPicker = document.querySelector('[name="id"]');
		this.variantPicker?.addEventListener("change", (e) => {
			this.updateDescription(e.target.value);
		});

		const initialId = this.dataset.initialVariantId || this.variantPicker?.value;
		if (initialId) this.updateDescription(initialId);
	}

	getCurrentVariantId() {
		const input = document.querySelector('[name="id"]');
		if (input && input.value) return input.value;
		const checked = document.querySelector('[name="id"]:checked');
		if (checked && checked.value) return checked.value;
		const form = document.querySelector('form[action*="/cart"]');
		if (form && form.dataset?.selectedVariant) return form.dataset.selectedVariant;
		return null;
	}

	updateDescription(variantId) {
		const desc = this.descriptions[variantId]?.fabric_information || "";

		if (!this.descriptionBox) return;

		const parentBlock = this.descriptionBox.closest(".product-info__block-item");

		if (desc) {
			this.descriptionBox.textContent = desc;
			if (parentBlock) parentBlock.style.display = "block";
		} else {
			this.descriptionBox.textContent = "";
			if (parentBlock) parentBlock.style.display = "none";
		}
	}

	waitForSizeChartImgAndUpdate(variantId) {
		const tryUpdate = () => {
		const img = document.querySelector('#size-chart-img');
		if (img) {
			this.updateSizeChartWithImg(img, variantId);
			return true;
		}
		return false;
		};

		if (tryUpdate()) return;

		const observer = new MutationObserver((mutations, obs) => {
		for (const m of mutations) {
			for (const node of m.addedNodes) {
			if (!(node instanceof HTMLElement)) continue;
			const found = node.querySelector?.('#size-chart-img') || (node.id === 'size-chart-img' ? node : null);
			if (found) {
				this.updateSizeChartWithImg(found, variantId);
				obs.disconnect();
				return;
			}
			}
		}
		});

		observer.observe(document.body, { childList: true, subtree: true });

		let attempts = 0;
		const interval = setInterval(() => {
		attempts++;
		if (tryUpdate() || attempts > 20) {
			clearInterval(interval);
			observer.disconnect();
		}
		}, 50);
	}

	updateSizeChartWithImg(imgElement, variantId) {
		const variantImage = this.descriptions[variantId]?.size_chart_image;
		const productImage = this.productImage;
		const src = variantImage || productImage || '';
		if (!src) {
			imgElement.src = '';
			imgElement.removeAttribute('srcset');
			return;
		}
		imgElement.src = src;
		imgElement.removeAttribute('srcset');
		if (this.descriptions[variantId]?.size_chart_alt) {
			imgElement.alt = this.descriptions[variantId].size_chart_alt;
		}
	}
}

customElements.define("variant-metafield", VariantMetafield);
